import type { TerminalBalanceTransfer } from '@/generated/graphql';

import { IAdmin, mapGQLAdmin } from './admin';

export interface ITerminalBalanceTransfer {
  id: string;
  amount: number;
  createdAt: string;
  updatedAt: string;

  admin: IAdmin;
}

export interface ITerminalBalanceTransferTable {
  id: string;
  amount: number;
  createdAt: string;
  username: string;
}

export interface ITerminalBalanceTransferQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLTerminalBalanceTransfer(gql_terminalBalanceTransfer?: TerminalBalanceTransfer | null): ITerminalBalanceTransfer {
  return {
    id: gql_terminalBalanceTransfer?.id ?? '',
    amount: gql_terminalBalanceTransfer ? gql_terminalBalanceTransfer.amount ?? 0 : 0,

    updatedAt: gql_terminalBalanceTransfer ? gql_terminalBalanceTransfer.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    admin: mapGQLAdmin(gql_terminalBalanceTransfer?.admin),
    createdAt: gql_terminalBalanceTransfer
      ? new Date(gql_terminalBalanceTransfer.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
